const Rings = require('./Modes/Rings.js')
const Spiral = require('./Modes/Spiral.js')

class Canvas {
  constructor (canvasElement, modus, settings) {
    this.canvasElement = canvasElement
    this.setModus(modus, settings)
  }

  setModus (modus, settings) {
    if (modus === 'rings') {
      this.modus = new Rings(this.canvasElement, settings)
    } else if (modus === 'spiral') {
      this.modus = new Spiral(this.canvasElement, settings)
    }
  }

  setDemension (layout, width, height) {
    console.log(layout)
    if (layout === 'full') {
      this.canvasElement.width = width - 8
      this.canvasElement.height = height - 8
    } else {
      const dimension = Math.min(width - 8, height - 8)
      this.canvasElement.width = dimension
      this.canvasElement.height = dimension
    }
    this.modus.updateDemsnion()
  }

  setSettings (settings) {
    this.modus.updateSettings(settings)
  }

  startAnimation () {
    this.modus.startAnimation()
  }

  pauseAnimation () {
    this.modus.pauseAnimation()
  }

  stopAnimation () {
    this.modus.stopAnimation()
  }
}

module.exports = Canvas
